import { MouseEventHandler } from 'react';

import { SearchResultListComponentProps } from '@components/ui/search/SearchBarInput/SearchBarSearchInput/SearchBarSearchInputInterface';
import { SearchViewModel } from '@api/v3';

import { BookerSearchInputWrapper } from './styled';
import { PastSearchesHeader } from './PastSearchesHeader';
import { StyledList } from './StyledList';
import { BookerSearchViewModel } from './BookerSearchViewModel';
import PopularSearches from './PopularSearches';

interface SearchResultProps {
  data: BookerSearchViewModel[];
  history?: BookerSearchViewModel[];
  showPastSearch?: boolean;
  onClearClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  callBack?: (item: BookerSearchViewModel) => void;
  onRemoveItem?: (item: BookerSearchViewModel) => void;
  inputLocation?: string;
  popularSearchItems?: SearchViewModel[];
  onPopularSearchItemSelected?: (item: SearchViewModel) => void;
}
export const SearchResult = ({
  searchText,
  onChange,
  data = [],
  history = [],
  showPastSearch,
  onClearClick,
  callBack,
  onRemoveItem,
  inputLocation = '',
  popularSearchItems,
  onPopularSearchItemSelected,
}: SearchResultListComponentProps & SearchResultProps) => {
  const showPastSearches =
    history.length > 0 && showPastSearch && searchText.length === 0;

  const showPopularSearch =
    popularSearchItems &&
    popularSearchItems?.length > 0 &&
    searchText.length === 0;
  return (
    <BookerSearchInputWrapper>
      {showPastSearches ? (
        <>
          <PastSearchesHeader onClearClick={onClearClick} />

          <StyledList
            searchText={searchText}
            data={history.slice(0, 3)}
            onChange={onChange}
            callBack={callBack}
            showRemoveButton={true}
            onRemoveItem={onRemoveItem}
            inputLocation={inputLocation}
          />
        </>
      ) : null}

      {showPopularSearch ? (
        <PopularSearches
          items={popularSearchItems}
          onSelectItem={(item) => {
            onChange(item);
            onPopularSearchItemSelected?.(item);
          }}
        />
      ) : null}

      {data.length > 0 ? (
        <>
          <StyledList
            searchText={searchText}
            data={data || []}
            onChange={onChange}
            inputLocation={inputLocation}
          />
        </>
      ) : null}
    </BookerSearchInputWrapper>
  );
};
